/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	Button,
	// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
	__experimentalConfirmDialog as ConfirmDialog,
} from '@wordpress/components';
import { useState, Fragment, useContext } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import { store as noticesStore } from '@wordpress/notices';
import { store as coreStore } from '@wordpress/core-data';
import { SettingsContext } from '../context/settings-context';

/**
 * Renders the update settings buttons and animation
 *
 * @since 2.1.0
 * @param {Object} props All the props passed to this function
 * @return {string}		 Return the rendered JSX
 */
export default function SaveButton( props ) {
	const {
		text = __( 'Save settings', 'popper' ),
		disabled,
		variant = 'primary',
		isDestructive = false,
		withConfirm = false,
		confirmMessage = __( 'Are you sure?', 'popper' ),
	} = props;

	const [ showConfirmDialog, setShowConfirmDialog ] = useState( false );
	const { createNotice } = useDispatch( noticesStore );
	const { settings, saveSettings } = useContext( SettingsContext );

	const { isSaving, hasEdits } = useSelect(
		( select ) => ( {
			isSaving: select( coreStore ).isSavingEntityRecord(
				'root',
				'site'
			),
			hasEdits: select( coreStore ).hasEditsForEntityRecord(
				'root',
				'site',
				undefined,
				'formello'
			),
		} ),
		[]
	);

	const action = () => {
		if ( withConfirm ) {
			setShowConfirmDialog( true );
		} else {
			saveSettings();
		}
	};

	return (
		<Fragment>
			<div className="setting-controls__save-settings">
				<Button
					onClick={ action }
					isBusy={ isSaving }
					disabled={ ! hasEdits || isSaving }
					aria-disabled={ ! hasEdits || isSaving }
					variant={ variant }
					isDestructive={ isDestructive }
				>
					{ text }
				</Button>
				<ConfirmDialog
					isOpen={ showConfirmDialog }
					onConfirm={ saveSettings }
					onCancel={ () => setShowConfirmDialog( false ) }
				>
					{ confirmMessage }
				</ConfirmDialog>
			</div>
		</Fragment>
	);
}
